import { string, shape } from 'prop-types';
import React from 'react';

import IconCheckBullet from '@/components/assets/IconCheckBullet/IconCheckBullet';

// import { IconLoader } from '../../../../images/IconLoader';
import { Text } from '../../../../module/Text';
import { Title } from '../../../../module/Title';

const DefaultItem = ({ data }) => {
  const { title, description } = data;
  return (
    <div className="flex flex-col gap-3 py-6 md:px-8">
      <IconCheckBullet width={30} height={30} color="#004D69" />
      {/* <IconLoader
        src="/icons/streamline-light/Check Circle 1.svg"
        className="w-7 h-7 text-blue-regal"
      /> */}
      <Title as="h3" size="xl" color="purple-cannon" weight="extrabold">
        {title}
      </Title>
      <Text color="gray-deep">
        <p>{description}</p>
      </Text>
    </div>
  );
};

DefaultItem.propTypes = {
  data: shape({
    title: string,
    description: string,
  }),
};

DefaultItem.defaultProps = {
  data: {
    title: '',
    description: '',
  },
};

export default DefaultItem;
